import type { GraphQLFormattedError } from 'graphql';

import type { PageDataError } from '#src/shared/error';
import { ForbiddenError, UnauthorizedError } from '#src/shared/error';

export function handleGqlAuthorizationErrors(
	errors: readonly GraphQLFormattedError[] | undefined,
	defaultError: PageDataError<string>,
): void {
	if (!errors?.length) {
		return;
	}

	if (errors.find(({ message }) => message === 'UNAUTHORIZED')) {
		throw new UnauthorizedError();
	}
	if (errors.find(({ message }) => message === 'FORBIDDEN')) {
		throw new ForbiddenError();
	}

	// There were errors but not auth errors
	throw defaultError;
}
